import React, { ReactElement } from 'react';

import { ApiErrorMessageContainerStyled, ErrorMessageTextStyled } from './styled';

const ErrorContainer: React.FC<{ children?: ReactElement; className?: string }> = ({ children, className }) => (
  <ApiErrorMessageContainerStyled className={className}>
    <ErrorMessageTextStyled>{children}</ErrorMessageTextStyled>
  </ApiErrorMessageContainerStyled>
);

export default React.memo(ErrorContainer);
